<script>
import axios from 'axios'
import Vue from 'vue'
let MarcasModel = new Vue({
  name: 'MarcasModel',
  methods: {
    obtener() {
      return new Promise(async (resolve, reject) => {
        try {
          let tiposEquipos = (await axios.get('../../catalogos/marcas.txt'))
            .data.split('\n')
          resolve(tiposEquipos)
        } catch (e) {
          console.error("ETIPOS", e)
          reject(e)
        }
      })
    }
  }
})
export default MarcasModel
</script>
